module.exports = __webpack_public_path__ + "images/sprites/tax_icons/tax_icon_category_farm_machinery_9bc82f6583ed50e95fa46599d1601cd4.png";